import React from 'react';
import { CountryCode } from '@dayetopia/types';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { TextVariant, Typography } from '@components/shared/design/Typography';
import TamponPresetSmallBoxesDropdown from '@components/storefront/TamponPresetSmallBoxesDropdown';
import TamponSelection from '@components/storefront/TamponSelection';
import TamponSelectionPresetDropdown from '@components/storefront/TamponSelectionPresetDropdown';
import { useCountry } from '@hooks/useCountry';
import { useShoppingContext } from './ProductShoppingContext';

const TamponsPaymentBoxes: React.FC = () => {
  const { t } = useTranslation();
  const { prices, subscriptions, preselectedTamponBoxes, boxState, setBoxState } = useShoppingContext();
  const { country } = useCountry();
  if (!boxState) {
    return null;
  }

  return (
    <div style={{ width: '100%' }}>
      <Typography $variant={TextVariant.UpperText5}>{t('components.your-box')}</Typography>
      <div style={{ height: '15px' }} />
      {country === CountryCode.US ? (
        <TamponSelectionPresetDropdown boxStateOuter={boxState} setBoxStateOuter={setBoxState} />
      ) : (
        <>
          {preselectedTamponBoxes ? (
            <TamponPresetSmallBoxesDropdown prices={prices} subscriptions={subscriptions} boxStateOuter={boxState} setBoxStateOuter={setBoxState} />
          ) : (
            <TamponSelection boxStateOuter={boxState} setBoxStateOuter={setBoxState} />
          )}
        </>
      )}
      <div style={{ height: '30px' }} />
    </div>
  );
};

export default TamponsPaymentBoxes;
